module.exports = __webpack_public_path__ + "static/the-switch-persona-1e8031569213edd33a646786abb9b3cd.jpg";